/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Conversation statuses.
 */

export const ConversationStatus = {
    Idle: 'idle',
    Thinking: 'thinking',
} as const;

export type ConversationStatus = typeof ConversationStatus[keyof typeof ConversationStatus];



